export default "41744c75f68862c9.svg"